import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const fileUrl = (p) => {
  if (!p) return null;
  if (p.startsWith("http") || p.startsWith("/images")) return p;
  return `${API}/files/${p}`;
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0] || "field"}: ${x.msg.replace("Value error, ", "")}`).join("; ");
  if (typeof d === "string") return d;
  if (e?.response?.status === 429) return "Too many attempts. Please wait a minute and try again.";
  return "Something went wrong. Please try again.";
};

export function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data, opts = {}) => {
    const token = await getToken();
    const res = await api.request({ method, url, data, headers: { Authorization: `Bearer ${token}` }, ...opts });
    return res.data;
  }, [getToken]);
}

export const fmtDate = (d) => {
  if (!d) return "TBA";
  const dt = new Date(d);
  return isNaN(dt) ? d : dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};
